import { useQueryParams } from 'src/shared/hooks/useQueryParams';
export function useIsExtraModule() {
    return useQueryParams('extra').getQueryParam() === 'true';
}
